"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const differenceInHours_1 = __importDefault(require("date-fns/differenceInHours"));
const getTime_1 = __importDefault(require("date-fns/getTime"));
const AGREEMENT_STATUS_1 = __importDefault(require("../../../../constants/app/AGREEMENT_STATUS"));
const BOOKING_STATUS_1 = __importDefault(require("../../../../constants/app/BOOKING_STATUS"));
const BOOKING_TYPE_1 = __importDefault(require("../../../../constants/app/BOOKING_TYPE"));
const getKSADate_1 = __importDefault(require("../../../../utils/store/getKSADate"));
const getLocalTimeStampFromGMT_1 = __importDefault(require("../../../../utils/store/getLocalTimeStampFromGMT"));
const NO_SHOW_THRESHOLD_HOUR = 24;
const YAQEEN_BOOKING_REFERENCE_KEY = 'q2_';
/**
 * Returns booking status
 *  ongoing
 *  cancelled
 *  upcoming
 *  completed
 * @param {string} referenceNo
 * @param {number} pickupDateTime in Epoch timestamp
 * @param {number} dropOffDateTime in Epoch timestamp
 * @param {string} bookingStatus
 * @param {string} agreementStatus
 * @returns {string}
 */
const getBookingStatus = (referenceNo, pickupDateTime, dropOffDateTime, bookingStatus, agreementStatus) => {
    const hasNoAgreement = !agreementStatus;
    const isYaqeenBooking = referenceNo && referenceNo.startsWith(YAQEEN_BOOKING_REFERENCE_KEY);
    if (isYaqeenBooking) {
        return BOOKING_TYPE_1.default[bookingStatus];
    }
    // if cancelled
    if (bookingStatus.toLowerCase() === BOOKING_STATUS_1.default.CANCELLED.toLowerCase() ||
        hasNoAgreement) {
        return BOOKING_TYPE_1.default.CANCELLED;
    }
    if (bookingStatus.toLowerCase() === BOOKING_STATUS_1.default.CREATED.toLowerCase()) {
        // if not cancelled
        // based on pickup & drop date times we can check
        // if a booking is in future, completed or ongoing
        const today = (0, getKSADate_1.default)(new Date()); // in KSA time zone
        const todayTimeStamp = (0, getTime_1.default)(today); // in KSA time zone
        const localPickUpDate = (0, getLocalTimeStampFromGMT_1.default)(pickupDateTime); // in KSA time zone
        const pickupTimeStamp = (0, getTime_1.default)(localPickUpDate);
        const isUpcoming = agreementStatus.toLowerCase() === AGREEMENT_STATUS_1.default.PENDING.toLowerCase();
        const is24HoursPassed = (0, differenceInHours_1.default)(todayTimeStamp, pickupTimeStamp) >=
            NO_SHOW_THRESHOLD_HOUR;
        // upcoming status
        if (!is24HoursPassed && isUpcoming) {
            return BOOKING_TYPE_1.default.UPCOMING; // pick up date is in future
        }
        // completed status
        if (agreementStatus.toLowerCase() === AGREEMENT_STATUS_1.default.CLOSE.toLowerCase()) {
            return BOOKING_TYPE_1.default.COMPLETED; // dropoff date in in past
        }
        // ongoing status
        if (todayTimeStamp >= pickupTimeStamp &&
            agreementStatus.toLowerCase() === AGREEMENT_STATUS_1.default.OPEN.toLowerCase()) {
            return BOOKING_TYPE_1.default.ONGOING; // pickup date < today
        }
        // no-show status
        if (is24HoursPassed &&
            (agreementStatus.toLowerCase() !== AGREEMENT_STATUS_1.default.OPEN.toLowerCase() ||
                isUpcoming ||
                hasNoAgreement)) {
            return BOOKING_TYPE_1.default.NO_SHOW;
        }
    }
    return ''; // safe return
};
exports.default = getBookingStatus;
